import { CoSignPermissionMetadata } from "@/core/types";
import dayjs from "@/lib/helpers/dayjs";

type EnabledByLabelProps = {
  requirementReason: CoSignPermissionMetadata["requirement_reason"];
  requirementReasonDetails?: CoSignPermissionMetadata["requirement_reason_details"];
  stateUpdatedAt: CoSignPermissionMetadata["state_updated_at"];
  stateUpdatedByName: CoSignPermissionMetadata["state_updated_by_name"];
};

export function EnabledByLabel({
  requirementReason,
  requirementReasonDetails,
  stateUpdatedAt,
  stateUpdatedByName,
}: EnabledByLabelProps) {
  const formattedDate = dayjs(stateUpdatedAt).format("MM/DD/YYYY");

  const isOtherReason = requirementReason === "Other";
  const displayReason =
    isOtherReason && requirementReasonDetails ? requirementReasonDetails : requirementReason;

  return (
    <p className="tw:text-sm tw:text-text-tertiary">
      Enabled by {stateUpdatedByName} {formattedDate}. Reason: {displayReason}
    </p>
  );
}
